import { isStudentUser } from "./isStudentUser";

const STUDENT_PORTAL_SLUG_KEY = "student_portal_slug";

export function normalizeOrgSlug(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "");
}

export function rememberStudentPortalSlug(slug) {
  const normalized = normalizeOrgSlug(slug);
  if (!normalized || typeof window === "undefined") return;
  localStorage.setItem(STUDENT_PORTAL_SLUG_KEY, normalized);
}

export function forgetStudentPortalSlug() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STUDENT_PORTAL_SLUG_KEY);
}

function slugFromUser(userData) {
  const org = Array.isArray(userData?.organization)
    ? userData.organization[0]
    : userData?.organization;
  return normalizeOrgSlug(
    org?.organization_short_name ||
      userData?.organizations?.[0]?.organization_short_name
  );
}

export function getLoginPathAfterLogout(userData) {
  if (typeof window !== "undefined") {
    const stored = normalizeOrgSlug(localStorage.getItem(STUDENT_PORTAL_SLUG_KEY));
    if (stored) return `/${stored}`;
  }

  if (isStudentUser(userData)) {
    const slug = slugFromUser(userData);
    if (slug) return `/${slug}`;
  }

  return "/login";
}
